import { fetchProjectBoardTasks, fetchTasks, type TaskRow } from '../api/tasks';

/** Match server normalizeTaskStatus enough to filter dependency lists reliably. */
function isTerminalDependencyStatus(status: string | undefined | null): boolean {
  const s = typeof status === 'string' ? status.trim() : String(status ?? '').trim();
  if (s === 'Void' || s === 'Completed') return true;
  const compact = s.toLowerCase().replace(/[-_\s]+/g, '');
  return compact === 'void' || compact === 'completed';
}

/**
 * Tasks that can be selected as a dependency: same project when `projectId` is set, otherwise all tasks visible in the user's lists.
 */
export async function loadTasksForDependencyPicker(
  userId: number,
  projectId: number | null,
  excludeTaskId?: number | null
): Promise<TaskRow[]> {
  let rows: TaskRow[] = [];
  if (projectId != null) {
    rows = await fetchProjectBoardTasks(projectId, userId);
  } else {
    const s = await fetchTasks(userId);
    rows = [...s.todo, ...s.inProgress, ...s.unassigned, ...s.onHold, ...s.watched];
  }
  const seen = new Map<number, TaskRow>();
  for (const t of rows) {
    if (excludeTaskId != null && t.id === excludeTaskId) continue;
    if (isTerminalDependencyStatus(t.status)) continue;
    if (!seen.has(t.id)) seen.set(t.id, t);
  }
  return Array.from(seen.values()).sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );
}
